<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    @click="action"
    data-name="svg-remove-tag"
  >
    <path
      data-name="svg-remove-tag"
      d="M8.82849 3.87874L6.70716 6.00006L8.82849 8.12138L8.12138 8.82849L6.00006 6.70717L3.87874 8.82849L3.17163 8.12138L5.29295 6.00006L3.17163 3.87874L3.87874 3.17163L6.00006 5.29295L8.12138 3.17163L8.82849 3.87874Z"
    />
  </svg>
</template>

<script>
  export default {
    props: {
      action: {
        type: Function,
        default: () => {}
      }
    }
  };
</script>
